export default {
  groupName: 'adpi-category-tentpole-events',
  appName: 'Quickview Live Events Dashboard',
  baseRoute: '/dashboard/adpi-quickview-live-events',
  label: 'Ad Effect Quickview Live Events Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Ad Effect Quickview Live Events Dashboard'
};



// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTentpoleEvents/config/main.js